module.exports = __webpack_public_path__ + "img/mt.37de9cc4.png";